import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/pages/Login/Login';
//import Profile from '@/pages/Profile/Profile';
import Error from '@/pages/Error/Error';


Vue.use(Router);

export default new Router({
  routes: [
    //{ path: '/', redirect: { name: 'Profile' } },
    { path: '/', redirect: { name: 'Login' } },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },

    {
      path: '*',
      name: 'Error',
      component: Error,
    },
  ],
});
